module.exports = __webpack_public_path__ + "img/westervelt-logo.cf6845d1.jpg";